import(/* webpackMode: "eager", webpackExports: ["WagmiProviderContainer"] */ "/var/app/app/wagmiProviderContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/app/components/CustomApolloProvider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/app/components/CustomNextProgress/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/app/components/CustomReactToastify/CustomToastContainer.tsx");
;
import(/* webpackMode: "eager" */ "/var/app/components/Footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/app/components/Header/index.tsx");
;
import(/* webpackMode: "eager" */ "/var/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/var/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/var/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"variable\":\"--font-inter\",\"style\":[\"normal\"],\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/var/app/styles/global.scss");
